import {
  Build,
  Delete,
  PlayArrow,
  Public,
  SignalWifi0Bar,
  SignalWifi4Bar,
  Lock,
} from '@mui/icons-material'
import { Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const IsOnlineIndicator = ({ isOnline }: { isOnline?: boolean }) => {
  const [t] = useTranslation('app')
  return (
    <Chip
      sx={{ m: 0.5, mt: 1 }}
      icon={isOnline ? <SignalWifi4Bar /> : <SignalWifi0Bar />}
      label={isOnline ? t('device.info.online') : t('device.info.offline')}
    />
  )
}

export const InServiceIndicator = ({ inService }: { inService?: boolean }) => {
  const [t] = useTranslation('app')
  return (
    <Chip
      sx={{ m: 0.5, mt: 1 }}
      icon={inService ? <Build /> : <Public />}
      label={
        inService ? t('device.info.inService') : t('device.info.onProduction')
      }
    />
  )
}

export const StatusCustomerIndicator = ({
  statusCustomer,
}: {
  statusCustomer?: string
}) => {
  const [t] = useTranslation('di')
  if (!statusCustomer) return null
  return (
    <Chip
      sx={{ m: 0.5, mt: 1 }}
      icon={statusCustomer === 'ACTIVE' ? <PlayArrow /> : <Delete />}
      label={`${t('device.statusCustomer')}: ${t(
        `statusCustomer.${statusCustomer}`,
      )}`}
    />
  )
}

export const ProjectIndicator = ({ projectName }: { projectName?: string }) => {
  if (!projectName) return null
  return <Chip sx={{ m: 0.5, mt: 1 }} icon={<Lock />} label={projectName} />
}
